import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import ConnectionRequestBox from 'components/ConnectionRequestBox';
import QuickLinksBox from 'components/QuickLinksBox';
import { Container, Nav, Stack } from 'react-bootstrap';
import Profile from 'components/UserBox/Profile';
import LeftMenus from 'components/UserBox/LeftMenus';
import { USER_TYPES } from 'constants/index';
import useAuthStore from 'store/auth';
import { isMobile } from 'react-device-detect';

const SidebarLayout: React.FC = () => {
	const navigate = useNavigate();
	const handleSelect = (value: string | null) => {
		if (value) {
			navigate(value);
		}
	};

	const {
		user: { userType = '' },
	} = useAuthStore((state: any) => state.userInfo);

	return (
		<section className="job-seeker-profile py-50">
			<Container fluid>
				<div className="d-flex flex-column flex-xl-row gap-3 gap-xxl-4">
					<div className="left-area d-flex flex-column">
						<div className="user-box white-box bg-white d-none d-xl-block">
							<Stack className="user text-center">
								<Profile />
								<hr className="m-0"></hr>
								<Nav
									variant="tabs"
									defaultActiveKey="/my-Preferences"
									className="user-actions border-0 flex-column text-start"
									onSelect={handleSelect}
								>
									<LeftMenus />
								</Nav>
							</Stack>
						</div>
						{userType === USER_TYPES.SEEKER && !isMobile && <ConnectionRequestBox />}
						{/* {!isMobile && <QuickLinksBox />} */}
					</div>
					<div className="right-area flex-1 d-flex flex-column">
						<Outlet />
					</div>
				</div>
			</Container>
		</section>
	);
};

export default SidebarLayout;
